import { waitUntil } from '../../util/rxjs';
import { DirectConnectHealthStatus } from '../model/direct-connect.model';

export interface DirectConnectPollHealthOptions {
  interval?: number;
  timeout?: number;
}

const pollDirectConnectHealth = async (
  url: string,
  options?: DirectConnectPollHealthOptions
): Promise<DirectConnectHealthStatus | undefined> => {
  const result = await waitUntil<DirectConnectHealthStatus | undefined>({
    key: 'direct-connect-health-poll',
    action: async () => {
      return getDirectConnectHealth(url);
    },
    interval: options?.interval ?? 1_000,
    timeout: options?.timeout ?? 30_000,
  });

  return result;
};

const getDirectConnectHealth = async (
  url: string
): Promise<DirectConnectHealthStatus | undefined> => {
  const response = await fetch(new URL('health', url), {
    method: 'GET',
  });

  if (response.ok) {
    const json = await response.json();
    return json as DirectConnectHealthStatus;
  }
};

export { getDirectConnectHealth, pollDirectConnectHealth };
